const regex = {
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // 이메일
  text: /^[\s\S]{2,}$/, // 2자 이상
  phoneNumber: /^01([0|1|6|7|8|9])[-\s]?(\d{3,4})[-\s]?(\d{4})$/, // 전화번호
  certNum: /^\d{6}$/, // 인증번호
  // 영문/숫자/특수기호 중 2가지 이상 조합 (글자수 8자~16자)
  pw: /^(?=.{8,16}$)(?:(?=.*[A-Za-z])(?=.*\d)|(?=.*[A-Za-z])(?=.*[!@#$%^&*(),.?":{}|<>])|(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]))[A-Za-z\d!@#$%^&*(),.?":{}|<>]+$/,
  nickname: /^[가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9]{2,10}$/, // 닉네임
};

export default regex;
